import { Controller } from "@hotwired/stimulus"

// Cable broadcasts (created message, title, reply) can reach the browser
// out of order relative to the HTTP turbo-stream response, and a stale
// bubble render can land after a newer one. This controller makes the
// thread order-independent: it drops a stream render for a bubble that
// would regress its version, and re-sorts the thread by message id after
// every render that goes through.
export default class extends Controller {
  connect() {
    this.onBeforeStreamRender = this.onBeforeStreamRender.bind(this)
    document.addEventListener("turbo:before-stream-render", this.onBeforeStreamRender)
  }

  disconnect() {
    document.removeEventListener("turbo:before-stream-render", this.onBeforeStreamRender)
  }

  onBeforeStreamRender(event) {
    const incoming = event.target.templateElement?.content?.firstElementChild
    if (!incoming || !incoming.dataset.messageId) return

    const existing = this.element.querySelector(`#${incoming.id}`)
    if (existing) {
      const existingVersion = BigInt(existing.dataset.messageVersion)
      const incomingVersion = BigInt(incoming.dataset.messageVersion)
      if (existingVersion > incomingVersion) {
        event.preventDefault()
        return
      }
    }

    const render = event.detail.render
    event.detail.render = async (streamElement) => {
      await render(streamElement)
      this.sort()
    }
  }

  sort() {
    const children = [ ...this.element.children ].filter((el) => el.dataset.messageId)
    const sorted = [ ...children ].sort((a, b) => Number(a.dataset.messageId) - Number(b.dataset.messageId))

    const alreadySorted = children.every((el, i) => el === sorted[i])
    if (alreadySorted) return

    sorted.forEach((el) => this.element.appendChild(el))
  }
}
